import { mergeClasses } from '../../../helpers/merge-classes';
import type { CalendarWeekType } from '../calendar-types';
import type { BaseAtomProps } from './calendar-atom.types';
import { CalendarWeek } from './calendar-week';

type CalendarMonthProps = BaseAtomProps & {
  weeks: CalendarWeekType[];
};

export const CalendarMonth = ({ className, weeks, ...rest }: CalendarMonthProps) => (
  <div className={mergeClasses('cal__month', className)} {...rest}>
    {weeks.map((days, i) => (
      <CalendarWeek key={`week-${i}`} days={days} />
    ))}
  </div>
);
